import React from 'react';
import Button from '../../../UI/Button/Button';
import CountryById from "../CountrySelect/CountryById";

const DesktopAddressesList = ({ addresses, setEditAddressId, removeAddress }) => {
    return (
        <div className="addresses-list">
            <span className="addresses-cols">Ime</span>
            <span className="addresses-cols">Prezime</span>
            <span className="addresses-cols">Adresa ulice</span>
            <span className="addresses-cols">Grad</span>
            <span className="addresses-cols">Država</span>
            <span className="addresses-cols">Županija</span>
            <span className="addresses-cols">Poštanski broj</span>
            <span className="addresses-cols">Telefon</span>
            <span />
            <span />
            {addresses.map(({ id, firstname, lastname, street, city, country_id, country_code, postcode, telephone }) => {
                return <React.Fragment key={id}>
                    <span>{firstname}</span>
                    <span>{lastname}</span>
                    <span>{street[0]}</span>
                    <span>{city}</span>
                    <CountryById id={country_code || country_id} />
                    <span/>
                    <span>{postcode}</span>
                    <span>{telephone}</span>
                    <Button text="Uredite" type="button" trait="profile" onClick={() => setEditAddressId(id)}/>
                    <Button text="Uklonite" type="button" trait="profile"
                            onClick={() => removeAddress({variables: {id: +id}})}/>
                </React.Fragment>
            })}
        </div>
    );
};

export default DesktopAddressesList;
